(function(){
    'use strict';
    class Countdown extends HTMLElement {
      constructor() {
        super();
  
  
        const style = `
            <style>
                :host {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .countdown-contanier {
                    display: inline-block;
                    font-size: 0;
                    text-align: right;
                }
                .clock-icon {
                    display: inline-block;
                    vertical-align: top;
                    margin: 2px 10px;
                }
                .countdown-section {
                    position: relative;
                    font-size: 0;
                    display: flex;
                    flex-direction: column;
                    color:red;
                }
                .countdown-content {
                    display: flex;
                    font-size: 0;
                }
                .countdown-time-box {
                  display: flex;
                  align-items: center;
                }
                .countdown-contanier {display: flex;align-items: center;line-height:0;}
                .clock-icon svg { width: 24px; height:24px; }
                .countdown-postfix { 
                    color: rgba(0, 0, 0, 0.30);
                    font-size:16px;width:16px;
                    margin: 0 8px;
                    font-weight: 600;
                    height: 20px;
                    line-height: 20px;
                    display: inline-block;
                    text-align: center;
                    color: ${this.themeColor};
                }
                .countdown-time {
                    width:48px;
                    height:48px;
                    backdrop-filter: blur(4.94px);
                    font-size:18px;
                    line-height:48px;
                    border-radius:var(--radius-countdown-time, 10px);
                    font-weight: 700;
                    background: var(--bg-countdown-time, rgba(0, 0, 0, 0.10));
                    color: #000;
                    text-align: center;
                    color: ${this.timeColor};
                }
                .countdown-time-name{
                    width: 48px;
                    color: rgba(0, 0, 0, 0.70);
                    font-size: 12px;
                    font-weight: 500;
                    display: inline-block;
                    font-weight: 500;
                    line-height: 14px;
                    text-align: center;
                    margin-top: 4px;
                    color: ${this.themeColor};
                }

                @media (max-width: 768px) {
                    .countdown-postfix {
                        width: 10px;
                        height: 18px;
                        line-height: 18px;
                    }
                    
                    .countdown-time {
                        width: 18px;
                        height: 18px;
                        line-height: 18px;
                        font-size: 12px;
                    }
                    .clock-icon {
                        margin: 1px 8px;
                    }
                    
                    .clock-icon {margin-left:0;margin-right:12px;}
                    .clock-icon svg { width: 16px; height:16px;}
                    .countdown-time {width:36px;height:36px;backdrop-filter: blur(4.94px);font-size:12px;line-height:36px;border-radius:4px;}
                    .countdown-postfix { margin: 0 2px;}
                    .countdown-postfix{font-size:14px;}
                    .countdown-time-name {
                      width: 36px;
                      font-size: 12px;
                    }
                }
            </style>
        `;
  
        const template = `
            <div class="countdown-contanier">
                <div class="countdown-content"></div>
            </div>
        `;
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = `${style}${template}`;
        this.countdownContainer = shadowRoot.querySelector('.countdown-contanier');


        if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', function(event) {
                if (this.interval) clearInterval(this.interval);
                this.initData();
            });
          }
      }
  
      static get observedAttributes() {
        return [
          'countdown-date',
          'time-color',
          'time-theme-color',
          'container',
          'on-countdown-end'
        ];
      }
  
      get countdownDate() {
        return this.getAttribute('countdown-date');
      }

      get timeColor() {
        return this.getAttribute('time-color');
      }
  
      get themeColor() {
        return this.getAttribute('time-theme-color');
      }
  
      get container() {
        return this.getAttribute('container');
      }
  
  
      get onCountdownEnd() {
        const callbackName = this.getAttribute('on-countdown-end');
        return callbackName ? window[callbackName] : null;
      }
  
      async connectedCallback() {
        this.initData();
      }
  
      initData() {
        let endTimeStamp = this.countdownDate? Number(this.countdownDate) : new Date().getTime() + 1 * 3600 * 1000;
        this.finalDate = new Date(endTimeStamp);
        this.start();
      }
  
      start() {
        if (!this.checkOverdueDate()) return;
        // 初始化时创建DOM结构
        this.initializeCountdownDOM();
        // 首次显示数据
        this.updateCountdownValues(this.getRemainingTime());
        this.interval = setInterval(() => this.display(), 1000);
      }
  
      display() {
        // 只更新变化的数字部分
        this.updateCountdownValues(this.getRemainingTime());
      }
  
      checkOverdueDate() {
        if (this.getTotal() >= 0) {
          return true;
        }
        if (this.interval) clearInterval(this.interval);
        if (this.container) {
          document.querySelector(`#${this.container}`).classList.add('d-none-important');
        }
        // 调用倒计时结束回调函数
        if (this.onCountdownEnd) {
          this.onCountdownEnd();
        }
        document.querySelector('.dl-countdown-banner').style.display = 'none';
        return false;
      }
  
      getTotal() {
        return Date.parse(this.finalDate) - Date.parse(new Date());
      }
  
      getRemainingTime() {
        if (!this.checkOverdueDate()) {
          return false;
        }
        const total = this.getTotal();

        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));
  
        return {
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        };
      }
  
      // 初始化倒计时DOM结构
      initializeCountdownDOM() {
        let html = '';
        let days = 'Days';
        let hours = 'Hours';
        let minutes = 'Mins';
        let seconds = 'Secs';
        
        html += this.buildSectionHTML('00', ':',days);
        html += this.buildSectionHTML('00', ':',hours);
        html += this.buildSectionHTML('00', ':',minutes);
        html += this.buildSectionHTML('00', '', seconds);
        
        this.countdownContainer.querySelector('.countdown-content').innerHTML = html;
      }
      
      // 只更新数字部分
      updateCountdownValues(time) {
        if (!time) return;
        
        const sections = this.countdownContainer.querySelectorAll('.countdown-section');
        if (sections.length !== 4) return;
        
        // 更新天数
        this.updateTimeValue(sections[0], time.days);
        // 更新小时
        this.updateTimeValue(sections[1], time.hours);
        // 更新分钟
        this.updateTimeValue(sections[2], time.minutes);
        // 更新秒数
        this.updateTimeValue(sections[3], time.seconds);
      }
      
      // 更新单个时间值
      updateTimeValue(section, value) {
        if (value === false || value === undefined) value = 0;
        let timeToString = value.toString();
        if (timeToString.length < 2) timeToString = `0${value}`;
        
        const timeElement = section.querySelector('.countdown-time');
        if (timeElement && timeElement.textContent !== timeToString) {
          timeElement.textContent = timeToString;
        }
      }
      
      // 仅用于初始化DOM结构
      render(time) {
        this.initializeCountdownDOM();
        this.updateCountdownValues(time);
    }
  
      buildSectionHTML(time, postfix,timeName) {
        if (time === false || time === undefined) time = "0";
        let timeToString = time.toString();
        if (timeToString.length < 2) timeToString = `0${time}`;
  
        return `<span class="countdown-section">
                    <span class="countdown-time-box">
                      <span class="countdown-time">${timeToString}</span>
                      <span class="countdown-postfix">${postfix}</span>
                    </span>
                    <span class="countdown-time-name">${timeName}</span>
                </span>`;
      }
  
      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }
    }
  
    customElements.define('countdown-banner', Countdown);
})();